import { useEffect, useState } from 'react';
import { Grid } from 'antd';
import { useTheme } from 'styled-components';
import { IconSvg } from 'shared/icon';
import { useCreateOrEditUserConfigMutation } from 'app/userPreferences/api';
import { selectUserConfigMenuCollapse } from 'app/userPreferences/selectors';
import { useAppSelector } from 'store/hooks';
import { selectActiveMenu } from 'app/settings/selectors';
import { settingKeys } from 'constants/configKeys';
import { MenusItem } from 'router/types';
import { StyledCollapseMenuMobile, StyledIconMenu } from 'shared/icon/Icon.styled';
import SiderMenu from './SiderMenu';
import { StyledSidebar, StyledSiderWrapper } from './Layout.styled';

export interface SiderProps {
  menus?: MenusItem[],
  width: string,
  collapsedWidth: string
  page?: string,
}

const Sider = ({
  menus = [], width, collapsedWidth, page = '',
}:SiderProps) => {
  const [createOrEditUserConfig] = useCreateOrEditUserConfigMutation();
  const menuCollapse = useAppSelector(selectUserConfigMenuCollapse);
  const activeMenu = useAppSelector(selectActiveMenu);

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const { colors } = useTheme();
  // initially collapsed for mobile case
  const [collapsed, setCollapsed] = useState<boolean>(true);
  // open sub-menu for initial load
  const [initialSubMenu, setInitialSubMenu] = useState<boolean>(true);

  // breakpoint hook works with delay
  useEffect(() => {
    setCollapsed(isMobile || !!menuCollapse);
  }, [isMobile, menuCollapse]);

  const collapseMenu = () => {
    setCollapsed(!collapsed);
    // only for desktop sizes
    if (!isMobile) {
      setInitialSubMenu(!collapsed);
      createOrEditUserConfig({ key: settingKeys.menuCollapse, configValue: !collapsed, skipGlobalLoading: true });
    }
  };

  return (
    <>
      <StyledCollapseMenuMobile onClick={collapseMenu} $collapsed={collapsed}>
        <div>
          <span />
        </div>
      </StyledCollapseMenuMobile>
      <StyledSiderWrapper width={width} collapsedWidth={collapsedWidth} collapsed={collapsed} className={page} reverseArrow>
        <StyledSidebar className="side-menu">
          <SiderMenu menus={menus} page={page} collapsed={collapsed} activeMenu={activeMenu} initialSubMenu={initialSubMenu} setInitialSubMenu={setInitialSubMenu} setCollapsed={setCollapsed} />
          <StyledIconMenu onClick={collapseMenu}>
            <IconSvg icon={collapsed ? 'MenuUnFold' : 'MenuFold'} width="0.93rem" height="0.8rem" color={colors.primaryText} />
          </StyledIconMenu>
        </StyledSidebar>
      </StyledSiderWrapper>
    </>
  );
};

export default Sider;
